export { default } from "ember-shiki/modifiers/shiki-render";
